import {
  List,
  Datagrid,
  TextField,
  NumberField,
  ReferenceField,
  EditButton,
  DeleteButton,
  SearchInput,
  FilterButton,
  CreateButton,
  TopToolbar,
  ExportButton,
  SelectInput,
  ReferenceInput,
} from "react-admin";

const modelFilters = [
  <SearchInput source="q" alwaysOn key="q" />,
  <ReferenceInput source="project_id" reference="projects" key="project_id">
    <SelectInput optionText="name" label="Progetto" />
  </ReferenceInput>,
];

function ListActions() {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportButton />
    </TopToolbar>
  );
}

export function ModelList() {
  return (
    <List
      filters={modelFilters}
      actions={<ListActions />}
      sort={{ field: "name", order: "ASC" }}
    >
      <Datagrid rowClick="edit" bulkActionButtons={false}>
        <TextField source="id" label="ID" />
        <ReferenceField source="project_id" reference="projects" label="Progetto">
          <TextField source="name" />
        </ReferenceField>
        <TextField source="parent_id" label="ID padre" emptyText="—" />
        <TextField source="name" label="Nome" />
        <NumberField source="depth" label="Profondità" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
}
